import { render, staticRenderFns } from "./SingleBar.vue?vue&type=template&id=622a9a1c&"
import script from "./SingleBar.vue?vue&type=script&lang=js&"
export * from "./SingleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports